export default {"src":"/_next/static/media/spiritory-checkmark.6d8067cb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};